// Corrected EditAuthentication
// Added submit button inside the form
import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EditAuthentication = ({ authentication = {}, onChange, onSubmit }) => {


  if (!authentication) {
    return <div className="text-center mt-5">Authentication data is missing...</div>;
  }

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const updatedAuthData = {
      ...authentication,
      [name]: type === "checkbox" ? checked : value,
    };

    if (name === "noEmail") {
      if (checked) {
        const username = sessionStorage.getItem("username") || "";
        updatedAuthData.userName = username;
        updatedAuthData.confirmUserName = username;
      } else {
        const email = authentication.id ? (localStorage.getItem("userEmail") || "") : "";
        updatedAuthData.userName = email;
        updatedAuthData.confirmUserName = email;
      }
    }

    onChange(updatedAuthData);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const success = await onSubmit(authentication);
    if (success) {
      onChange({
        ...authentication,
        password: "",
        confirmPassword: "",
      });
    }
  };

  const Styles = `
    .title {
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .form-container {
    
      border-top: 3px solid #004aad;
      background-color: #e9ecef;
      padding: 15px;
    }
    .form-group {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }
    .form-group label {
      width: 150px;
      font-weight: bold;
      margin-right: 10px;
      margin-left: 10px;
    }
    .form-group input[type="text"],
    .form-group input[type="password"] {
      flex: 1;
      padding: 8px;
      border: 1px solid #ccc;
      border-radius: 4px;
      max-width: 300px;
    }
    .form-group input[type="checkbox"] {
      margin-right: 10px;
    }
    .user-info {
      margin: 10px 10px 20px 10px;
      padding: 10px;
      background-color: #e9ecef;
      border-radius: 4px;
    }
    .submit-button {
      margin-left: 10px;
      padding: 8px 16px;
      background-color: #004aad;
      color: #fff;
      border: none;
      border-radius: 4px;
      cursor: pointer;
    }
    .submit-button:hover {
      background-color: #003a8c;
    }
  `;

  const { noEmail = false, firstName = "", lastName = "", currentPasswordMask = "********" } = authentication;

  return (
    <div style={{ width: "120%", maxWidth: "1800px", margin: "0 auto", padding: "0px" }}>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <div className="row">
        <div className="col-md-10">
          <style>{Styles}</style>
          <h1>Authentication</h1>
          <div className="form-container">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>ID:</label>
                <input
                  type="text"
                  name="id"
                  value={authentication.id || ""}
                  onChange={handleInputChange}
                  disabled={true}
                />
              </div>
              <div className="form-group">
                <label>No email?</label>
                <input
                  type="checkbox"
                  name="noEmail"
                  checked={noEmail}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>{noEmail ? "Username" : "Email"}:</label>
                <input
                  type="text"
                  name="userName"
                  value={authentication.userName || ""}
                  onChange={handleInputChange}
                  disabled={false} // Enable always for editing
                />
              </div>
              <div className="form-group">
                <label>Confirm {noEmail ? "Username" : "Email"}:</label>
                <input
                  type="text"
                  name="confirmUserName"
                  value={authentication.confirmUserName || ""}
                  onChange={handleInputChange}
                  disabled={false}
                />
              </div>
              <div className="form-group">
                <label>Current Password:</label>
                <input
                  type="text"
                  name="currentPasswordMask"
                  value={currentPasswordMask}
                  disabled={true}
                />
              </div>
              <div className="form-group">
                <label>New Password:</label>
                <input
                  type="password"
                  name="password"
                  value={authentication.password || ""}
                  onChange={handleInputChange}
                  placeholder="Enter new password"
                />
              </div>
              <div className="form-group">
                <label>Confirm Password:</label>
                <input
                  type="password"
                  name="confirmPassword"
                  value={authentication.confirmPassword || ""}
                  onChange={handleInputChange}
                  placeholder="Confirm new password"
                />
              </div>
              <div className="form-group">
                <button type="submit" className="submit-button">Save Authentication</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditAuthentication;